import { render, staticRenderFns } from "./PDFTextTag.vue?vue&type=template&id=1f331350&"
import script from "./PDFTextTag.vue?vue&type=script&lang=js&"
export * from "./PDFTextTag.vue?vue&type=script&lang=js&"
import style0 from "./PDFTextTag.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports